import { appPath, stripBasePath } from '@/lib/basePath';
import {
  getAdminSurfaceContext,
  resolveAdminSurface,
  type AdminSurface,
  type AdminSurfaceContext,
} from '@easyflow/shared';

/**
 * Contesto centralizzato della superficie amministrativa corrente. Non usa mai
 * lo slug tenant: il nuovo host CRM espone la propria SPA alla root, mentre il
 * vecchio build `/master/crm` resta leggibile solo per compatibilità locale.
 */
export function getCurrentAdminSurface(): AdminSurface {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;
  return resolveAdminSurface(hostname, stripBasePath(pathname));
}

/** True solo sul nuovo hostname CRM, non sul percorso legacy `/master/crm`. */
export function isCurrentDedicatedCrmHost(): boolean {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;
  return resolveAdminSurface(hostname, '/') === 'crm';
}

export function getCurrentAdminSurfaceContext(): AdminSurfaceContext {
  const surface = getCurrentAdminSurface();
  return getAdminSurfaceContext(surface, {
    legacyCrmPath: surface === 'crm' && import.meta.env.BASE_URL.startsWith('/master/'),
  });
}

/** Login route per React Router (senza basename). */
export function getLoginRoutePath(): string {
  return getCurrentAdminSurfaceContext().loginPath;
}

/** Login URL absolute same-origin (con basename) per window.location.href. */
export function getLoginPath(): string {
  return appPath(getLoginRoutePath());
}

/** Percorso CRM coerente per entrambe le modalità di serving. */
export function getCrmRoutePath(section?: string): string {
  const { crmRoutePrefix } = getCurrentAdminSurfaceContext();
  const normalizedSection = section?.replace(/^\/+/, '') ?? '';
  const path = normalizedSection ? `/${normalizedSection}` : '';
  return `${crmRoutePrefix}${path}` || '/';
}
